import { render, staticRenderFns } from "./DisabledElementWithTitle.vue?vue&type=template&id=c4aca55e"
import script from "./DisabledElementWithTitle.vue?vue&type=script&lang=js"
export * from "./DisabledElementWithTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports